// Minimal local replacements for lodash `get`/`set` — they support the only form
// this codebase uses: dot-delimited string paths (no bracket / array-index
// notation, no array auto-creation).

// Reads the value at a dot path, or `undefined` if any segment is missing.
// Returns `any` to mirror lodash's signature (callers feed the result straight
// into loosely-typed positions, e.g. a ReactNode error prop).
export const get = (object: unknown, path: string): any => {
  let current: unknown = object;

  for (const key of path.split('.')) {
    if (typeof current !== 'object' || current === null) {
      return undefined;
    }

    current = (current as Record<string, unknown>)[key];
  }

  return current;
};

// Sets the value at a dot path, mutating `object` in place (creating intermediate
// objects as needed) and preserving sibling keys — matching lodash `set`.
export const set = <T>(object: T, path: string, value: unknown): T => {
  const keys = path.split('.');
  let current = object as Record<string, unknown>;

  for (const key of keys.slice(0, -1)) {
    const next = current[key];

    if (typeof next !== 'object' || next === null) {
      current[key] = {};
    }

    current = current[key] as Record<string, unknown>;
  }

  current[keys.at(-1)!] = value;

  return object;
};
